import { useQuery } from '@apollo/client';
import { GET_LOCATION_NAME } from '../graphql/utils/queries';
import { Location } from '../interfaces/RiskHub';

type FetchedLocation = {
  findLocationByUuid: Location;
};

/**
 * Hook to fetch the location name for a given location ID
 * @param locationId - The ID of the location to fetch the name for
 * @returns An object containing the location name and a boolean indicating if the location is loading
 */
export const useLocationName = (locationId: string | undefined) => {
  const { data: locationData, loading: isLocationNameLoading, error: locationNameError } = useQuery<FetchedLocation>(GET_LOCATION_NAME, {
    variables: {
      uuid: locationId,
    },
    skip: !locationId,
  });

  const locationName = locationData?.findLocationByUuid.locationName ?? '';

  return { locationName, isLocationNameLoading, locationNameError };
};
